import { useQuery, useQueryClient } from 'react-query'
import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

export const fetchAllAnalysis = async ({
  page = 0,
  limit = 10,
  tags = [],
  sort_order,
  sample_name,
  organization_id,
  suborganisation_id,
  hidden = false,
} = {}) => {
  const params = new URLSearchParams()

  if (page) params.append('page', page)
  if (limit) params.append('limit', limit)
  if (tags && tags.length > 0) {
    params.append('tags', tags.join(','))
  }
  if (sort_order) params.append('sort_order', sort_order)
  if (sample_name) params.append('sample_name', sample_name)
  if (organization_id) params.append('organization_id', organization_id)
  // One organisation out of the user's own and its sub-organisations; omitted = all of them.
  if (suborganisation_id) params.append('suborganisation_id', suborganisation_id)
  // Hidden is a MODE, not a tag: the list shows either live or hidden analyses.
  if (hidden) params.append('hidden', 'true')

  const { data } = await axios.get(`${API_BASE_URL}/analysis/list?${params.toString()}`)
  return data
}

export const updateSampleAlias = async (analysisId, sampleAlias) => {
  const { data } = await axios.patch(`${API_BASE_URL}/analysis/${analysisId}/sample-alias`, {
    sample_alias: sampleAlias,
  })
  return data
}

export const useAnalysis = ({
  page = 0,
  limit = 10,
  tags = [],
  sort_order,
  sample_name,
  organization_id,
  suborganisation_id,
  hidden = false,
} = {}) => {
  const queryClient = useQueryClient()

  const query = useQuery(
    ['all-analysis', page, limit, tags, sort_order, sample_name, organization_id, suborganisation_id, hidden],
    () => fetchAllAnalysis({ page, limit, tags, sort_order, sample_name, organization_id, suborganisation_id, hidden }),
    {
      refetchInterval: 1000 * 15, // 15 seconds
      refetchIntervalInBackground: 1000 * 60, // 1 minute
      refetchOnWindowFocus: true,
      keepPreviousData: true,
    },
  )

  const refresh = async () => {
    console.log('REFRESHING')
    await queryClient.refetchQueries('all-analysis')
    await queryClient.resetQueries('all-analysis')
  }

  return { query, refresh }
}
